import { Link } from "react-router";
import type { PlaySessionStatus, PlaySessionSummary } from "@storyai/shared";
import { useDeleteSession } from "../lib/queries";
import { Badge, InlineConfirm, formatDate } from "./ui";

const STATUS_LABEL: Record<PlaySessionStatus, string> = {
  active: "Active",
  finished: "Finished",
  unavailable: "Unavailable",
};

export function SessionStatusBadge({ status }: { status: PlaySessionStatus }) {
  return <span className={`badge badge-status-${status}`}>{STATUS_LABEL[status]}</span>;
}

/** One session row, used on the story landing page and the Playing page. */
export function SessionRow({ session }: { session: PlaySessionSummary }) {
  const del = useDeleteSession();
  const playable = session.storyAvailable;
  const href = `/stories/${session.storyId}/sessions/${session.id}`;

  return (
    <li className="session-row">
      <div className="session-row-main">
        <div className="session-row-title">
          {playable ? <Link to={href}>{session.name}</Link> : <span>{session.name}</span>}
          {session.versionTitle && <Badge tone="muted">{session.versionTitle}</Badge>}
          {session.isPlaytest && <Badge tone="accent">Playtest</Badge>}
          <SessionStatusBadge status={session.status} />
        </div>
        <div className="muted small">
          {session.currentChapterTitle ? `Chapter: ${session.currentChapterTitle}` : "No chapter"}
          {" · "}
          last played {formatDate(session.lastPlayedAt)}
        </div>
      </div>
      <div className="session-row-side">
        {playable ? (
          <Link to={href} className="btn btn-sm btn-primary">
            {session.status === "finished" ? "Review" : "Continue"}
          </Link>
        ) : (
          <span className="muted small">Unavailable</span>
        )}
        <InlineConfirm
          label="Delete"
          question="Delete this session?"
          confirmLabel="Delete"
          busy={del.isPending}
          onConfirm={() => del.mutate({ storyId: session.storyId, sessionId: session.id })}
        />
      </div>
    </li>
  );
}
